import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {DatePicker, Form} from 'antd';
import dayjs from 'dayjs';

const DateAttribute = ({attributeMetadata}) => {

  const form = Form.useFormInstance();

  const division = Form.useWatch('division', form);
  const location = Form.useWatch('location', form);
  const jobRole = Form.useWatch('jobRole', form);

  const initialRef = useRef(null);

  useEffect(() => {
    if (division && location && jobRole && !initialRef.current)
    {initialRef.current = {division, location, jobRole};
    }
  }, [division, location, jobRole]);

  if (attributeMetadata.id === 'transferDate') {
    const initial = initialRef.current;

    attributeMetadata.editable =
        initial &&
        (
          division?.id !== initial.division?.id ||
            location?.id !== initial.location?.id ||
            jobRole?.id !== initial.jobRole?.id
        );
  }

  const getDisabledDate = () => {
    if (
      attributeMetadata.id === 'dateOfReporting' ||
        attributeMetadata.new_id === 'dateOfReporting'
    ) {
      return current => {
        const joiningDate = form.getFieldValue('dateOfJoining');

        if (!joiningDate) {
          return current && current > dayjs().endOf('day');
        }

        const disableBeforeJoining =
            current &&
            current < dayjs(joiningDate).startOf('day');

        const disableFutureDates =
            current &&
            current > dayjs().endOf('day');

        return disableBeforeJoining || disableFutureDates;
      };
    }
    if (
      attributeMetadata.new_id === 'dateOfTermination' ||
        attributeMetadata.id === 'dateOfTermination'
    ) {
      return current => {
        const fromDate =
            form.getFieldValue('fromDate') ||
            form.getFieldValue('dateOfJoining') ||
            form.getFieldValue('dateOfReporting');

        const disableBeforeFromDate =
            fromDate &&
            current &&
            current < dayjs(fromDate).startOf('day');

        const disableFutureDates =
            current &&
            current > dayjs().endOf('day');

        return disableBeforeFromDate || disableFutureDates;
      };
    }
    if (attributeMetadata.disableToDate) {
      return current => {
        const fromDate = form.getFieldValue('fromDate') || form.getFieldValue('dateOfJoining') || form.getFieldValue('dateOfReporting');
        if (!fromDate) {return false;}
        return current && current < dayjs(fromDate).startOf('day');
      };
    }

    if (attributeMetadata.disableFuture) {
      return current => current && current > dayjs().endOf('day');
    }

    if (attributeMetadata.disablePast) {
      return current => current && current < dayjs().startOf('day');
    }

    return undefined;
  };

  return (
    <Form.Item
      name={[attributeMetadata.id]}
      label={attributeMetadata.label}
      rules={attributeMetadata.validation_rules}
    >
      <DatePicker
        format={attributeMetadata.date_format}
        onChange={(date, dateString) => dateString}
        disabled={!attributeMetadata.editable}
        disabledDate={getDisabledDate()}
      />
    </Form.Item>
  );
};

DateAttribute.propTypes = {
  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    new_id: PropTypes.string,
    editable: PropTypes.bool,
    validation_rules: PropTypes.array,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    date_format: PropTypes.string,
    disableFuture: PropTypes.bool,
    disablePast: PropTypes.bool,
    disableToDate: PropTypes.bool,
  }).isRequired,
};

export default DateAttribute;
